import PropTypes from "prop-types"
import InProgress from "./in-progress"
import Error from "./error"
import Link from "./link"
import ServerLink from "./server-link"

export default function Download({ success, total, createdAt, data: { link, filePath, error } }) {
  if (error) {
    return <Error error={error} createdAt={createdAt} />
  }
  if (link) {
    return <Link link={link} createdAt={createdAt} />
  }
  if (filePath) {
    return <ServerLink filePath={filePath} createdAt={createdAt} />
  }
  return <InProgress success={success} total={total} createdAt={createdAt} />
}

Download.propTypes = {
  success: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  createdAt: PropTypes.string,
  data: PropTypes.shape({
    link: PropTypes.string,
    filePath: PropTypes.string,
    error: PropTypes.string,
  }),
}
